module.exports = __webpack_public_path__ + "./WelsenPhoto_38836120080dcbfae7ac087a1a074f36.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/WelsenPhoto.png
// module id = 511
// module chunks = 0